<template>
  <div class="suggestionsPage">意见建议</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.suggestionsPage {
}
</style>
